import React, { useState } from 'react';
import './Header.css';
import Logo from './media/logoframe.png';
import MenuIcon from './media/MenuIcon.png';
import CloseIcon from './media/CloseIcon.png';

const Header = ({ onOpenModal }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleNavClick = (sectionId) => {
    closeMenu();
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handleCallBackClick = () => {
    closeMenu();
    onOpenModal();
  };

  // Функция для прокрутки к началу страницы
  const scrollToTop = () => {
    closeMenu(); // Закрываем меню, если оно открыто
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      <header className="header-menu">
        <div className="menu-content">
          {/* Добавляем обработчик клика для логотипа */}
          <div className="logo" onClick={scrollToTop} style={{ cursor: 'pointer' }}>
            <img src={Logo} alt='Logo' />
          </div>
          <div className="menu-icon" onClick={toggleMenu}>
            <img src={MenuIcon} alt='Menu' />
          </div>
        </div>
      </header>

      {/* Модальное окно меню */}
      {isMenuOpen && (
        <div className="modal-overlay" onClick={closeMenu}>
          <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
            <div className="menu-header">
              {/* Добавляем обработчик клика для логотипа в меню */}
              <div onClick={scrollToTop} style={{ cursor: 'pointer' }}>
                <img src={Logo} alt='Logo' className="menu-logo" />
              </div>
              <div className="close-icon" onClick={closeMenu}>
                <img src={CloseIcon} alt='Close' />
              </div>
            </div>
            
            <nav className="menu-nav">
              <a href="#для-кого" className="menu-item" onClick={() => handleNavClick('для-кого')}>Для кого</a>
              <a href="#о-сервисе" className="menu-item" onClick={() => handleNavClick('о-сервисе')}>О сервисе</a>
              <a href="#как-работает" className="menu-item" onClick={() => handleNavClick('как-работает')}>Как работает</a>
              <a href="#команда" className="menu-item" onClick={() => handleNavClick('команда')}>Команда</a>
              <a href="#контакты" className="menu-item" onClick={() => handleNavClick('контакты')}>Контакты</a>
            </nav>
            
            <button className="menu-button" onClick={handleCallBackClick}>
              Обратный звонок
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;